import { useTranslation } from 'react-i18next';
import { testimonials } from '@/mocks/meats';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function TestimonialsSection() {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollReveal(0.1);

  const trustItems = [
    { icon: 'ri-verified-badge-line', labelKey: 'trust_usda' },
    { icon: 'ri-recycle-line', labelKey: 'trust_eco' },
    { icon: 'ri-truck-line', labelKey: 'trust_delivery' },
    { icon: 'ri-heart-pulse-line', labelKey: 'trust_antibiotics' },
  ];

  return (
    <section id="testimonios" className="py-16 md:py-24 bg-brand-cream">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Header */}
        <div
          ref={ref}
          className={`text-center mb-12 md:mb-16 transition-all duration-700 ${
            isVisible
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-brand-red" />
            <span className="text-brand-red text-sm font-medium">
              {t('testimonials_badge')}
            </span>
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-brand-dark mb-4">
            {t('testimonials_title')}
          </h2>
          <p className="text-brand-dark/50 text-base md:text-lg max-w-2xl mx-auto">
            {t('testimonials_subtitle')}
          </p>
        </div>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {testimonials.map((tItem, idx) => (
            <div
              key={tItem.id}
              className="bg-white rounded-xl p-5 md:p-6 shadow-sm hover:shadow-lg transition-all duration-500 hover:-translate-y-1"
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: tItem.rating }).map((_, i) => (
                  <i
                    key={i}
                    className="ri-star-fill text-brand-gold text-sm"
                  />
                ))}
              </div>

              {/* Text */}
              <p className="text-brand-dark/70 text-sm md:text-base leading-relaxed mb-6">
                &ldquo;{t(tItem.textKey)}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-brand-dark/5">
                <img
                  src={tItem.avatar}
                  alt={tItem.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="font-semibold text-brand-dark text-sm">
                    {tItem.name}
                  </div>
                  <div className="text-brand-dark/40 text-xs">
                    {tItem.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust indicators */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12 mt-12 md:mt-16 pt-8 border-t border-brand-dark/10">
          {trustItems.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-2 text-brand-dark/40 hover:text-brand-red transition-colors duration-300"
            >
              <i className={`${item.icon} text-brand-red text-xl`} />
              <span className="text-sm font-medium">{t(item.labelKey)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}